export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MailEditor.vue?vue&type=template&id=40198484&"


//////////////////
// WEBPACK FOOTER
// ./src/views/MailEditor.vue?vue&type=template&id=40198484&
// module id = 526
// module chunks = 9